import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HTTPService, HelperService, DataService } from 'app/services';
import { error, log } from 'console';

@Component({
  selector: 'app-add-lead-source',
  templateUrl: './add-lead-source.component.html',
  styleUrls: ['./add-lead-source.component.scss'],
})
export class AddLeadSourceComponent implements OnInit {

  isProcessing: boolean = false;
  leadCategories: any[] = [
    {
      title: 'Website PPC',
      value: 'website ppc',
    },
    {
      title: 'Social Media',
      value: 'social media',
    },
    {
      title: 'Google Business',
      value: 'google business',
    },
    {
      title: 'BillBoard',
      value: 'billboard',
    },
  ];
  leadSource: any = {
    isActive: false,
    showLeadSource: false
  };
  previewLink: string;
  categorySuggestions = [];
  isApptRequestPortalEnabled: boolean;
  isEdit: boolean;

  constructor(
    private router: Router,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private httpService: HTTPService,
    private dataService: DataService,
    private helperService: HelperService // private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.getCategories();
    this.isApptRequestPortalEnabled = this.dataService.isApptRequestPortalEnabled;
    // this.categorySuggestions = [...this.leadCategories];
    this.isEdit = this.dialogConfig.data.isEdit;
    if(this.isEdit){
      this.leadSource = {...this.dialogConfig.data.leadSource};
    }
  }

  getCategories(){
    this.categorySuggestions = [];
    this.httpService.getCampaignCategory(['marketing']).then(category =>{
      category.map(element =>{
        this.categorySuggestions.push({title: element.name, value: element._id});
      });
    })
  }

  handleChange(name, value){
    if(name === 'category'){
      this.leadSource[name]
    }
    this.leadSource[name] = name === 'category' ? value.title : value;
  }

  handleSaveCategory(event){
    const payload ={
      name: event.name,
      type: 'marketing'
    }
    this.httpService.saveCampaignCategory(payload).then(res =>{
      this.leadSource.category = event.name;
      this.getCategories();
    })
  }

  handleSearchCategory(query: string){
    this.categorySuggestions = [];
    query = this.helperService.trimString(query);

    this.categorySuggestions = this.leadCategories.filter(({ title }) => {
      if (title && new RegExp(`${query}`, 'gi').test(title)) {
        return true;
      } else {
        return false;
      }
    });
  }

  handleClearSearch(){
    this.categorySuggestions = [...this.leadCategories];
  }

  onUpdateCategory(event){}

  closeModal(){
    if(this.isEdit){
      this.ref.close({isSuccess: true});
    }else{
      this.ref.close({isSuccess: false});
    }
  }

  copyLink(){
    const textCopied = document.createElement('textarea');
    textCopied.style.position = 'fixed';
    textCopied.style.left = '0';
    textCopied.style.top = '0';
    textCopied.style.opacity = '0';
    textCopied.value = this.leadSource.shortUrl;
    document.body.appendChild(textCopied);
    textCopied.focus();
    textCopied.select();
    document.execCommand('copy');
    document.body.removeChild(textCopied);
    this.helperService.showToaster('success', 'Copied!');
  }

  onSubmit(){
    if(!this.leadSource.title || this.leadSource.title.trim() === ''){
      this.helperService.showToaster('error', 'Name is required.')
      return;
    }
    this.isProcessing = true;
    if(this.isEdit){
      const payload = {
        title: this.leadSource.title,
        category: this.leadSource.category,
        showLeadSource: this.leadSource.showLeadSource,
        isActive : this.leadSource.isActive
      }
      this.httpService.updateLeadSource(this.leadSource._id, payload).then(res=>{
        this.isProcessing = false;
        this.ref.close({isSuccess: true});
        this.helperService.showToaster('success', 'Lead source saved successfully')
      },error=>{
        this.ref.close({isSuccess: false});
      });
    }else{
      this.httpService.saveLeadSource(this.leadSource).then(res=>{
        this.isProcessing = false;
        this.isEdit = true;
        this.leadSource = res;
        this.helperService.showToaster('success', 'Lead source created successfully');
      },error=>{
        this.ref.close({isSuccess: false});
      });
    }  
  }

}